import { combineReducers } from "redux";

import * as types from "../actions/types";
import auth from "./auth";
import config from "./config";
import datamodel from "./datamodel";
import system from "./system";
import threshold from "./threshold";

const appReducer = combineReducers({
  ...auth,
  ...datamodel,
  ...system,
  ...config,
  ...threshold,
});

export default (state, action) => {
  if (action.type === types.RESET) {
    state = undefined;
  }
  return appReducer(state, action);
};
